var moduleMap = {
	"./SurveyManagerApp": () => {
		return Promise.all([__webpack_require__.e(265), __webpack_require__.e(898), __webpack_require__.e(711), __webpack_require__.e(502), __webpack_require__.e(471), __webpack_require__.e(923), __webpack_require__.e(79), __webpack_require__.e(833)]).then(() => (() => ((__webpack_require__(85060)))));
	},
	"./SurveyClientConfigurationApp": () => {
		return Promise.all([__webpack_require__.e(265), __webpack_require__.e(114), __webpack_require__.e(471), __webpack_require__.e(923), __webpack_require__.e(116)]).then(() => (() => ((__webpack_require__(65633)))));
	},
	"./SurveysClassificationSubTopicApp": () => {
		return Promise.all([__webpack_require__.e(265), __webpack_require__.e(471), __webpack_require__.e(923), __webpack_require__.e(737)]).then(() => (() => ((__webpack_require__(78328)))));
	},
	"./SurveysWidgetGeneratorApp": () => {
		return Promise.all([__webpack_require__.e(265), __webpack_require__.e(898), __webpack_require__.e(863), __webpack_require__.e(335), __webpack_require__.e(471), __webpack_require__.e(923), __webpack_require__.e(79), __webpack_require__.e(853), __webpack_require__.e(50)]).then(() => (() => ((__webpack_require__(61050)))));
	},
	"./SurveysAnalysisApp": () => {
		return Promise.all([__webpack_require__.e(265), __webpack_require__.e(898), __webpack_require__.e(711), __webpack_require__.e(471), __webpack_require__.e(923), __webpack_require__.e(918)]).then(() => (() => ((__webpack_require__(30084)))));
	},
	"./SurveysVolumeTrackerApp": () => {
		return Promise.all([__webpack_require__.e(265), __webpack_require__.e(711), __webpack_require__.e(471), __webpack_require__.e(923), __webpack_require__.e(244)]).then(() => (() => ((__webpack_require__(51046)))));
	},
	"./surveysReportGeneratorConfig": () => {
		return Promise.all([__webpack_require__.e(265), __webpack_require__.e(898), __webpack_require__.e(863), __webpack_require__.e(471), __webpack_require__.e(79), __webpack_require__.e(853), __webpack_require__.e(316)]).then(() => (() => ((__webpack_require__(6316)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});